//Fedex Transportation Price
export const GET_SHIPPING_DATA = 'GET_SHIPPING_DATA';
export const GET_SHIPPING_DATA_SUCCESS = 'GET_SHIPPING_DATA_SUCCESS';
export const GET_SHIPPING_DATA_FAIL = 'GET_SHIPPING_DATA_FAIL';

// BOX SIZES
export const ADD_BOX_SIZE = 'ADD_BOX_SIZE';
export const ADD_BOX_SIZE_SUCCESS = 'ADD_BOX_SIZE_SUCCESS';
export const ADD_BOX_SIZE_FAIL = 'ADD_BOX_SIZE_FAIL';

export const UPDATE_BOX_SIZE = 'UPDATE_BOX_SIZE';
export const UPDATE_BOX_SIZE_SUCCESS = 'UPDATE_BOX_SIZE_SUCCESS';
export const UPDATE_BOX_SIZE_FAIL = 'UPDATE_BOX_SIZE_FAIL';

export const DELETE_BOX_SIZE = 'DELETE_BOX_SIZE';
export const DELETE_BOX_SIZE_SUCCESS = 'DELETE_BOX_SIZE_SUCCESS';
export const DELETE_BOX_SIZE_FAIL = 'DELETE_BOX_SIZE_FAIL';
// PRICES
export const ADD_PRICE = 'ADD_NEW_PRICE';
export const ADD_PRICE_SUCCESS = 'ADD_NEW_PRICE_SUCCESS';
export const ADD_PRICE_FAIL = 'ADD_NEW_PRICE_FAIL';

export const UPDATE_PRICE = 'UPDATE_PRICE';
export const UPDATE_PRICE_SUCCESS = 'UPDATE_PRICE_SUCCESS';
export const UPDATE_PRICE_FAIL = 'UPDATE_PRICE_FAIL';

export const DELETE_PRICE = 'DELETE_PRICE';
export const DELETE_PRICE_SUCCESS = 'DELETE_PRICE_SUCCESS';
export const DELETE_PRICE_FAIL = 'DELETE_PRICE_FAIL';

// TAX PRICES
export const ADD_TAX_PRICE = 'ADD_TAX_PRICE';
export const ADD_TAX_PRICE_SUCCESS = 'ADD_TAX_PRICE_SUCCESS';
export const ADD_TAX_PRICE_FAIL = 'ADD_TAX_PRICE_FAIL';

export const UPDATE_TAX_PRICE = 'UPDATE_TAX_PRICE';
export const UPDATE_TAX_PRICE_SUCCESS = 'UPDATE_TAX_PRICE_SUCCESS';
export const UPDATE_TAX_PRICE_FAIL = 'UPDATE_TAX_PRICE_FAIL';

export const DELETE_TAX_PRICE = 'DELETE_TAX_PRICE';
export const DELETE_TAX_PRICE_SUCCESS = 'DELETE_TAX_PRICE_SUCCESS';
export const DELETE_TAX_PRICE_FAIL = 'DELETE_TAX_PRICE_FAIL';

export const ADD_COUNTRIES = 'ADD_COUNTRIES';

// MOSCOW DATA
export const GET_MOSCOW_DATA = 'GET_MOSCOW_DATA';
export const GET_MOSCOW_DATA_SUCCESS = 'GET_MOSCOW_DATA_SUCCESS';
export const GET_MOSCOW_DATA_FAIL = 'GET_MOSCOW_DATA_FAIL';

export const SHOW_LOADING = 'SHOW_LOADING';
export const HIDE_LOADING = 'HIDE_LOADING';
